import styled from "styled-components"


const Container = styled.div`
 
`


const GorselOnaylari = () => {


  return (
    <Container>
     

    </Container>
  )
}

export default GorselOnaylari